import api from "../services/api"

export async function getDimensionObjects({ dimensionID, customerID }) {
  const requestData = await api.get("/api/v1/dimensionobjects", {
    params: {
      dimensionID,
      customerID,
    },
  })

  return requestData.data
}
